import { createFileRoute, notFound } from '@tanstack/react-router'
import { AgentCommunity } from '@/components/ledger/AgentCommunity'
import { ssrCommunity } from '@/server/ssr-community'
import { parseDiscussionFocus } from '@/lib/discussion-entry-location'
import { discussionHead } from '@/lib/discussion-head'
export const Route=createFileRoute('/{-$locale}/community_/$threadId')({
 validateSearch:(search)=>({focus:parseDiscussionFocus(search.focus)}),
 loaderDeps:({search})=>({focus:search.focus}),
 loader:async({params,deps})=>{const discussion=await ssrCommunity(params.threadId,undefined,undefined,deps.focus);if(!discussion)throw notFound();return {...discussion,focus:deps.focus}},
 head:({loaderData,params})=>discussionHead(loaderData,params.threadId,params.locale??'en-US',!!loaderData?.focus),
 component:()=> <AgentCommunity threadId={Route.useParams().threadId} initialDiscussion={Route.useLoaderData()} initialFocus={Route.useSearch().focus}/>,
})
